module.exports = __webpack_public_path__ + "static/media/Tuvalu - TV.35cc0290.png";